// „Platz voll“ für die Anzeige (Zwilling von lib/spot-full.js fullView, Gleichheit per Test).
const TZ = 'Europe/Berlin';
const ymd = (d) => {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' })
    .formatToParts(new Date(d)).map((x) => [x.type, x.value]));
  return Date.UTC(+p.year, +p.month - 1, +p.day);
};
export const isFull = (until, now = new Date()) => !!until && new Date(until).getTime() > new Date(now).getTime();
/** null | { tonight, freeFrom (Date), setAt (Date|null) } */
export function fullView(until, setAt, now = new Date()) {
  if (!isFull(until, now)) return null;
  const u = new Date(until);
  const days = Math.round((ymd(u) - ymd(now)) / 86400000);
  return { tonight: days <= 1, freeFrom: u, setAt: setAt ? new Date(setAt) : null };
}

/**
 * Banner „Ausgebucht“ als HTML-Text (App und öffentliche Seite teilen ihn). o = { t(key, vars), esc, locale }.
 * Texte: ui.full_tonight, ui.full_days, ui.full_free_from, ui.full_by_operator, ui.full_set_at.
 */
export function bannerHtml(v, o) {
  if (!v) return '';
  const day = new Intl.DateTimeFormat(o.locale, { timeZone: 'Europe/Berlin', weekday: 'short', day: 'numeric', month: 'short' }).format(v.freeFrom);
  const time = new Intl.DateTimeFormat(o.locale, { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit' }).format(v.freeFrom);
  const set = v.setAt ? new Intl.DateTimeFormat(o.locale, { timeZone: 'Europe/Berlin', weekday: 'short', hour: '2-digit', minute: '2-digit' }).format(v.setAt) : '';
  return '<section class="vc-full" role="status" aria-label="' + o.esc(o.t(v.tonight ? 'ui.full_tonight' : 'ui.full_days')) + '">'
    + '<span class="vc-full-badge" aria-hidden="true"><span class="vc-icon">event_busy</span></span>'
    + '<span class="vc-full-text"><strong class="vc-full-title">' + o.esc(o.t(v.tonight ? 'ui.full_tonight' : 'ui.full_days')) + '</strong>'
    + '<span class="vc-full-sub">' + o.esc(o.t('ui.full_free_from', { day, time })) + '</span>'
    + '<small class="vc-full-meta">' + o.esc(set ? o.t('ui.full_set_at', { when: set }) : o.t('ui.full_by_operator')) + '</small></span></section>';
}
